
var stateManager = require('../../state/stateManager.js');
var stringUtil = require('../../string/stringUtil.js');
var validator = require('../../validator/validator.js');
var commonUtility = require('../../domain/commonUtility.js');
var constants = require('../../domain/constants.js');

const staffAccessUtility = require('./staffAccessUtility.js');
const staffActivities = require('./staffActivities.js')

module.exports.getLoginStaffData = function()
{
    return stateManager.getStore().getState().staffLoginData;
}

module.exports.getLoginStaff = function()
{
    if (this.getLoginStaffData() == null)
        return null;

    return this.getLoginStaffData().staff;
}

module.exports.getLoginStaffCompleteName = function()
{
    var staff = this.getLoginStaff();
    if (staff == null)
        return "";

    return this.getStaffCompleteName(staff);
}

module.exports.getAllStaff = function()
{
    return stateManager.getStore().getState().staffs;
}

module.exports.getAllActiveStaff = function()
{
    return this.getAllStaff().filter(staff => stringUtil.isStringNullOrEmpty(staff.resignationDate));
}

module.exports.getStaffCompleteName = function(staff)
{
    if (staff == null) return "";
    
    var firstName = stringUtil.trimString(staff.firstName);
    var lastName = stringUtil.trimString(staff.lastName);
    if (stringUtil.isStringNullOrEmpty(firstName) && stringUtil.isStringNullOrEmpty(lastName))
        return "";

    if (stringUtil.isStringNullOrEmpty(lastName))
        return firstName;

    if (stringUtil.isStringNullOrEmpty(firstName))
        return lastName;

    return `${firstName} ${lastName}`;
}

module.exports.isStaffADriver = function(staff)
{
    return staffAccessUtility.canStaffPerformActivity(staff, staffActivities.canDeliverAnOrder);
}

module.exports.isStaffResigned = function (staff)
{
    return !stringUtil.isStringNullOrEmpty(staff.resignationDate)
}

module.exports.getStaffById = function(staffId)
{
    var staffs = this.getAllStaff();
    return staffs.find(s => stringUtil.areStringSame(s.id, staffId));
}

module.exports.inferStaffMealLimit = function()
{
    var loginStaff = this.getLoginStaff();
    var propertyOperatingConfiguration = commonUtility.getPropertyOperatingConfiguration();
    var franchisorOperatingConfiguration = commonUtility.getFranchisorOperatingConfiguration();
    
    if (!stringUtil.isStringNullOrEmpty(loginStaff.staffMealsLimit) && validator.isNumeric(loginStaff.staffMealsLimit))
        return loginStaff.staffMealsLimit;

    if (!stringUtil.isStringNullOrEmpty(propertyOperatingConfiguration.staffMealLimit) && validator.isNumeric(propertyOperatingConfiguration.staffMealLimit))
        return propertyOperatingConfiguration.staffMealLimit;

    if (!stringUtil.isStringNullOrEmpty(franchisorOperatingConfiguration.staffMealLimit) && validator.isNumeric(franchisorOperatingConfiguration.staffMealLimit))
        return franchisorOperatingConfiguration.staffMealLimit;

    return 0;
}

module.exports.inferStaffGuestMealLimit = function()
{
    var loginStaff = this.getLoginStaff();
    if (loginStaff.guestMealsLimit == null || loginStaff.guestMealsLimit <= constants.numericThresholdValue)
        return 0;

    return loginStaff.guestMealsLimit;
}

module.exports.inferStaffFreebiesMealLimit = function()
{
    var loginStaff = this.getLoginStaff();
    if (loginStaff.freebiesLimit == null || loginStaff.freebiesLimit <= constants.numericThresholdValue)
        return 0;

    return loginStaff.freebiesLimit;
}